import React from 'react'
import {useHistory, useParams} from 'react-router-dom'
import useCredit from 'bundles/admin/hooks/useCredit'
import useStateObject from 'admin/hooks/useStateObject'
import useDocument from 'admin/hooks/useDocument'
import InputField from 'admin/components/shared/InputField'
import DateField from 'admin/components/shared/DateField'
import Modal from 'admin/components/shared/Modal'
import Header from 'admin/components/shared/Header'
import EditField from './shared/EditField'
import useModal from '../hooks/useModal'

export default () => {
  const history = useHistory()
  const {organisationID} = useParams()
  const {accountId, popModal} = useModal()
  const {credit, errors, create} = useCredit(organisationID, accountId)
  const [form, setForm, resetForm] = useStateObject(credit)

  const title = 'New Credit'
  useDocument({title})

  const handleCreate = e => {
    create({...form, state: 'billable'}, () => handleClose(e))
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm(credit)
    popModal('new-credit', ['accountId'])
  }

  return (
    <Modal onClose={handleClose} flashId='new-account-credit'>
      <Header title={title}>
        <button className='button is-primary' onClick={handleCreate}>
          Create
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <form>
            <div className='field is-grouped'>
              <div className='control is-expanded'>
                <DateField name='date' value={form.date || ''} onChange={setForm} errors={errors.date} required />
              </div>

              <div className='control is-expanded'>
                <InputField
                  type='number'
                  name='amount'
                  value={form.amount || ''}
                  onChange={setForm}
                  errors={errors.amount}
                  min={0}
                  autoFocus={true}
                  required
                />

                <EditField
                  name='isWriteoff'
                  checked={!!form.isWriteoff}
                  label='Mark this credit as a write-off'
                  type='checkbox'
                  errors={errors.isWriteoff}
                  onChange={setForm}
                />
              </div>
            </div>

            <div className='field'>
              <div className='control'>
                <InputField
                  type='text'
                  name='description'
                  value={form.description || ''}
                  onChange={setForm}
                  errors={errors.description}
                  required
                />
              </div>
            </div>
          </form>
        </div>
      </section>
    </Modal>
  )
}
